import { gql } from "@apollo/client";

export const CREATE_CLIENT_HUB_ZONE_IMPORT_TASK_DOWNLOAD_TASK = gql`
    mutation CreateClientHubZoneImportTaskDownloadTask($taskNo: String!) {
        createClientHubZoneImportTaskDownloadTask(taskNo: $taskNo)
    }
`;

export interface CreateClientHubZoneImportTaskDownloadTaskResponse {
    createClientHubZoneImportTaskDownloadTask: string;
}

export interface CreateClientHubZoneImportTaskDownloadTaskVariables {
    taskNo: string;
}
